/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { CrmPersonAvatarAndTitleForm_CrmPersonFragmentDoc } from './CrmPersonAvatarAndTitleForm.generated.js';
import { CrmPersonInformationForm_CrmPersonFragmentDoc } from './CrmPersonInformationForm.generated.js';
import { CrmPersonCustomFieldsBox_CrmPersonFragmentDoc } from './boxes/CrmPersonCustomFieldsBox.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CrmPersonEditForm_CrmPersonQueryVariables = Types.Exact<{
  crmPersonId: Types.Scalars['ID']['input'];
}>;


export type CrmPersonEditForm_CrmPersonQuery = { crmPerson: { __typename: 'CrmPersonResult', crmPerson?: { __typename: 'CrmPerson', id: string, title: Types.Salutation, firstname: string, familyname: string, email: any, isEmailValid?: boolean | null, jobTitle: string, customTags: Array<string>, notices: string, crmCompany: { __typename: 'CrmCompany', id: string, title: string }, phones: Array<{ __typename: 'Phone', id: string, type: Types.PhoneType, main: boolean, number: string }>, avatar?: { __typename: 'AttachmentSnapshot', id: string, url: string } | null, customFields: Array<{ __typename: 'CustomFieldField', key: string, label: string, value: any, dataType: Types.CustomFieldDataType, group: string }> } | null } | { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } };


export const CrmPersonEditForm_CrmPersonDocument = gql`
    query CrmPersonEditForm_CrmPerson($crmPersonId: ID!) {
  crmPerson(id: $crmPersonId) {
    ... on CrmPersonResult {
      crmPerson {
        id
        ...CrmPersonAvatarAndTitleForm_CrmPerson
        ...CrmPersonInformationForm_CrmPerson
        ...CrmPersonCustomFieldsBox_CrmPerson
      }
    }
  }
}
    ${CrmPersonAvatarAndTitleForm_CrmPersonFragmentDoc}
${CrmPersonInformationForm_CrmPersonFragmentDoc}
${CrmPersonCustomFieldsBox_CrmPersonFragmentDoc}`;

/**
 * __useCrmPersonEditForm_CrmPersonQuery__
 *
 * To run a query within a React component, call `useCrmPersonEditForm_CrmPersonQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmPersonEditForm_CrmPersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmPersonEditForm_CrmPersonQuery({
 *   variables: {
 *      crmPersonId: // value for 'crmPersonId'
 *   },
 * });
 */
export function useCrmPersonEditForm_CrmPersonQuery(baseOptions: Apollo.QueryHookOptions<CrmPersonEditForm_CrmPersonQuery, CrmPersonEditForm_CrmPersonQueryVariables> & ({ variables: CrmPersonEditForm_CrmPersonQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CrmPersonEditForm_CrmPersonQuery, CrmPersonEditForm_CrmPersonQueryVariables>(CrmPersonEditForm_CrmPersonDocument, options);
      }
export function useCrmPersonEditForm_CrmPersonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrmPersonEditForm_CrmPersonQuery, CrmPersonEditForm_CrmPersonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CrmPersonEditForm_CrmPersonQuery, CrmPersonEditForm_CrmPersonQueryVariables>(CrmPersonEditForm_CrmPersonDocument, options);
        }
export function useCrmPersonEditForm_CrmPersonSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CrmPersonEditForm_CrmPersonQuery, CrmPersonEditForm_CrmPersonQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CrmPersonEditForm_CrmPersonQuery, CrmPersonEditForm_CrmPersonQueryVariables>(CrmPersonEditForm_CrmPersonDocument, options);
        }
export type CrmPersonEditForm_CrmPersonQueryHookResult = ReturnType<typeof useCrmPersonEditForm_CrmPersonQuery>;
export type CrmPersonEditForm_CrmPersonLazyQueryHookResult = ReturnType<typeof useCrmPersonEditForm_CrmPersonLazyQuery>;
export type CrmPersonEditForm_CrmPersonSuspenseQueryHookResult = ReturnType<typeof useCrmPersonEditForm_CrmPersonSuspenseQuery>;
export type CrmPersonEditForm_CrmPersonQueryResult = Apollo.QueryResult<CrmPersonEditForm_CrmPersonQuery, CrmPersonEditForm_CrmPersonQueryVariables>;